// 🚀 WICHTIG: Mini-Diagnose für Node-Polyfills (muss vor DAppKit-Import geladen werden)
import { Buffer } from 'buffer'
import process from 'process'

// 🚀 FIX: Telegram-Detection (verhindert Debug-Logs/Overlays)
const isTelegram = typeof navigator !== 'undefined' && /Telegram/i.test(navigator.userAgent || '');

// 🚀 WICHTIG: Verhindert Node-Erkennung -> zwingt Browser-Pfade
window.global = window.global || window
window.Buffer = window.Buffer || Buffer
window.process = window.process || process

// 🚀 WICHTIG: Verhindert Node-Erkennung -> zwingt Browser-Pfade
window.process.browser = true
window.process.version = ''       // manche checks machen .slice() darauf
window.process.versions = undefined

// 🚀 Live-Check: existieren http/https wirklich? (NUR wenn NICHT Telegram)
if (!isTelegram) {
  Promise.all([
    import('http').then(m => ({ name:'http',   ok: !!m.request, keys: Object.keys(m)})).catch(e => ({name:'http',   ok:false, err:String(e)})),
    import('https').then(m => ({ name:'https', ok: !!m.request, keys: Object.keys(m)})).catch(e => ({name:'https', ok:false, err:String(e)})),
  ]).then(r => void 0)

  } else {
  // In Telegram: Polyfills aktiviert, aber keine Debug-Logs
  // (stumm, damit keine Overlays/Toasts erscheinen)
}
